<template>
    <div>
      <a-modal
        :centered = "true"
        :visible="visible"
        :closable = "false"
        :keyboard="false"
        :maskClosable="false"
        width="800px"
        :mask="true"
        :destroyOnClose="true"
        @cancel="visible = false"
       >
        <div class="content">
          <div class="title_tip">
            <div class="tip_icon">
              <pt-icon type="icon-GroupCopy2" style="font-size: 30px"></pt-icon>
            </div>
            <div class="tip_content">
              {{$t("deal.dealBeOverDue.titleTip")}}
            </div>
          </div>
          <div class="table_div">
            <el-table
              class="dealBeOver_table"
              :data="tableData"
              style="width: 100%">
              <el-table-column
                prop="dealType"
                align="left"
                min-width="120"
                :label="$t('deal.dealBeOverDue.table.type')"
              >
                <template slot-scope="scope">
                  <div class="type-description">
                    <a-tooltip placement="top" :title="scope.row.dealType.split(',').map(e=>{return $t('deal.dealTypes.' + e)}).join(',')" v-if="scope.row.dealType.split(',').length > 1">
                      <div class="trackTypeText" v-text="scope.row.dealType.split(',').map(e=>{return $t('deal.dealTypes.' + e)}).join(',')"></div>
                    </a-tooltip>
                    <a-tooltip placement="top" :title="$t('deal.dealTypes.' + scope.row.dealType)" v-else>
                      <div class="trackTypeText" v-text="$t('deal.dealTypes.' + scope.row.dealType)"></div>
                    </a-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyShortName"
                min-width="100"
                align="center"
                show-overflow-tooltip
                :label="$t('deal.dealBeOverDue.table.companyName')"
              >
              </el-table-column>
              <el-table-column
                prop="projectStages"
                min-width="100"
                align="center"
                show-overflow-tooltip
                :label="$t('deal.dealBeOverDue.table.projectStages')">
                <template slot-scope="scope">
                  <span v-if="scope.row.dealOriginType == 1">{{$t('deal.dealDetails.leaseProjectStageTypes.'+scope.row.projectStages)}}</span>
                  <span v-if="scope.row.dealOriginType == 2">{{$t('deal.dealDetails.consultantProjectStageTypes.'+scope.row.projectStages)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="projectEndtime"
                align="left"
                min-width="120"
                :label="$t('deal.dealBeOverDue.table.projectEndtime')">
                <template slot-scope="scope">
                  <pt-month-picker  :allowClear="false" v-model="scope.row.projectEndtime" :blackhillsYellow="true" style="width: 80%;" :disabledDate="disabledMonthDate"></pt-month-picker>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div slot="footer">
          <a-button :loading="loading" key="submit" type="primary" style="margin-right: 40px" @click="saveChangeSubmit">{{$t('baseVO.save')}}</a-button>
        </div>
      </a-modal>
    </div>
</template>

<script>
  import DealApi from '@/api/mine/deal'
  import moment from "moment";
  export default {
    name: 'DealBeOverDue',
    data() {
      return {
        loading:false,
        visible:false,
        tableData:[]
      }
    },
    computed: {},
    mounted() {
      this.selectDeal();
    },
    methods: {
      saveChangeSubmit(){
        //校验修改的日期是否正确
        this.checkDate();
      },
      checkDate: function() {
        let type = false
        for(var i = 0;i < this.tableData.length;i++){
          //上个月最后一天时间
          let lastMonthEndDay = this.$moment().month(this.$moment().month() - 1).endOf('month').valueOf();
          //当前charge out时间
          let projectEndtime = Date.parse(this.tableData[i].projectEndtime.replace(/-/g,'/'));
          if(projectEndtime <= lastMonthEndDay){
            type = false;
            break;
          }else{
            type = true;
          }
        }
        if(!type){
          this.$message.error(this.$t("deal.dealBeOverDue.errorTop"))
          return false;
        }
        this.submit()
      },
      submit(){
        this.loading = true;
        DealApi.batchUpdateEndTime(this.tableData).then(res=>{
          if(res.code == 1){
            this.loading = false;
            this.selectDeal()
            this.$message.success(this.$t("deal.dealBeOverDue.successTip"))
          }
        }).finally(()=>{
          this.loading = false;
        })
      },
      disabledMonthDate(current){
        //禁用当前月之前的日期
        return current && current <= this.$moment().month(this.$moment().month() - 1).endOf('month');
      },
      selectDeal(){
        DealApi.selectBeOverdueAll().then(res=>{
          if(res.code == 1){
            if(res.data){
              if(res.data != null && res.data.length > 0){
                this.tableData = res.data;
                this.tableData.forEach(data=>{
                  data.projectEndtime = moment().format("YYYY-MM-DD");
                })
                this.visible = true;
              }else{
                this.visible = false;
              }
            }
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .table_div /deep/ .el-table td, .el-table th.is-leaf{
    border-bottom: 0px solid #EBEEF5 !important;
  }
  .table_div /deep/ .el-table--fit{
    padding: 20px;
  }
  .table_div /deep/  .el-table, .el-table__expanded-cell {
    background-color: rgba(248,249,251,0.62);
  }

  .table_div /deep/ .el-table tr {
    background-color:  rgba(248,249,251,0.62)!important;
  }
  .table_div /deep/  .el-table--enable-row-transition .el-table__body td, .el-table .cell{
    background-color:  rgba(248,249,251,0.62);
  }
  .content{
    padding: 0px 20px;
    height: 400px;
    .title_tip{
      display: flex;
      flex-direction: row;
      align-items: center;
      .tip_icon{

      }
      .tip_content{
        margin-left: 10px;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
      }
    }
    .table_div{
      margin-top: 20px;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      border-radius: 0px 0px 4px 4px;
    }
    .trackTypeText{
      width: 60px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>